// Origen del pipeline que emitio un documento. El backend lo devuelve como
// "pos" o "web" en /consultaDLQ y /consultaestadodoc.
export const ORIGEN_LABEL = {
  pos: 'POS',
  web: 'Emisión web',
};

// Cae de vuelta al valor crudo si aparece un origen que todavia no conocemos,
// en vez de dejar la celda vacia.
export const getOrigenLabel = (origen) => ORIGEN_LABEL[origen] ?? origen;
